<evrideo-clipping-studio-catalog-card
  [title]="item.name"
  [isEditMode]="isEditMode"
  [durationLabel]="durationLabel"
  (cardClick)="onAdd()"
  (editClick)="onAdd()"
>
  <div
    class="graphic-card__preview-inner"
    [ngClass]="'graphic-card__preview-inner--' + item.type"
  >
    <ng-container *ngIf="item.type === 'logo' && isLogoWithImage">
      <img class="graphic-card__logo-img" [src]="logoImageUrl" [alt]="item.name" />
    </ng-container>
    <ng-container *ngIf="item.type === 'logo' && !isLogoWithImage">
      <div
        class="graphic-card__logo-circle"
        [style.background]="'linear-gradient(135deg, ' + item.color + ' 0%, #2d3748 100%)'"
      >
        <span class="graphic-card__logo-initials">{{ initials }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="item.type === 'fruit-icon' && item.thumbnailUrl">
      <img class="graphic-card__logo-img" [src]="item.thumbnailUrl" [alt]="item.name" />
    </ng-container>
    <ng-container *ngIf="item.type === 'emoji'">
      <span class="graphic-card__emoji-preview">😀</span>
    </ng-container>
  </div>
</evrideo-clipping-studio-catalog-card>
